import { createSelector } from 'reselect'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import { isInsuranceBookingProtectionAvailableForCartItemTypes, isInsuranceBookingProtectionAvailableForRegions } from './isBookingProtectionAvailable'
import { isStandaloneFlights } from '../view/flights'
import isInsuranceBookingProtectionPostPurchaseEnabled from 'selectors/isInsuranceBookingProtectionPostPurchaseEnabled'
import getAllInsuranceBookingProtectionItems from '../view/items/getAllInsuranceBookingProtectionItems'
import { getOccupantsFromCartItems } from './insurance'

const isBookingProtectionEnabled = createSelector(
  (state: App.State) => getOccupantsFromCartItems(state),
  (state: App.State) => isInsuranceBookingProtectionAvailableForCartItemTypes(state),
  (state: App.State) => isInsuranceBookingProtectionAvailableForRegions(state),
  (state: App.State) => isStandaloneFlights(state),
  (state: App.State) => !!findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => isInsuranceBookingProtectionPostPurchaseEnabled(state),
  (state: App.State) => getAllInsuranceBookingProtectionItems(state),
  (
    occupants,
    isAvailableForItemTypes,
    insuranceBookingProtectionEnabled,
    isStandaloneFlightsCheckout,
    isPostPurchase,
    isPostPurchaseEnabled,
    insuranceBookingProtectionItems,
  ): boolean => {
    if (!occupants) return false

    if (!insuranceBookingProtectionEnabled) return false

    if (isPostPurchase) {
      return isPostPurchaseEnabled
    }

    if (!isAvailableForItemTypes) return false

    const containsEmbeddedFlightProtection = insuranceBookingProtectionItems.some(item => item.flightJourneysKeys?.length)
    if (isStandaloneFlightsCheckout && !containsEmbeddedFlightProtection) return false

    return true
  },
)

export default isBookingProtectionEnabled
